import { all, fork } from 'redux-saga/effects';
import { logError } from 'utils/logger';
import { configWatcher } from './config/actions';
import { gamesWatcher } from './games/actions';
import { leaguesWatcher } from './leagues/actions';
import { teamsWatcher } from './teams/actions';
import { teamAppWatcher } from './teamApp/actions';
import { userLoginWatcher } from './user/actions';
import { productAnalyticsWatcher } from './productAnalytics/actions';

export default function* rootSaga() {
  try {
    yield all([
      fork(leaguesWatcher),
      fork(teamsWatcher),
      fork(teamAppWatcher),
      fork(gamesWatcher),
      fork(configWatcher),
      fork(userLoginWatcher),
      fork(productAnalyticsWatcher),
    ]);
  } catch (error) {
    logError('Root Saga Error', error);
  }
}
